// extracted by mini-css-extract-plugin
export default {"container":"passwordConfirm_container__eoKaj","warning":"passwordConfirm_warning__nTFi6","buttonWrapperDefault":"passwordConfirm_buttonWrapperDefault__qqJj+"};